import { Link } from "react-router-dom";
import SVG from "../SVG";
export default function Custom({
  text,
  svg_name = "",
  svgClassName = "",
  href = "",
  className = "",
  textShadow = "",
  svgShadow = "",
  onClick = () => {
    return;
  },
}) {
  if (href === "") {
    return (
      <a
        className={`rounded-xl flex items-center justify-center gap-2.5 py-3 outline-none text-sm ${className}`}
        onClick={onClick}
      >
        <SVG
          name={svg_name}
          classname={`${svgClassName} ${svgShadow ? "drop-shadow-md" : ""}`}
        />
        {textShadow && <span className="drop-shadow-md">{text}</span>}
        {!textShadow && <span>{text}</span>}
      </a>
    );
  }
  return (
    <Link
      to={href}
      onClick={onClick}
      className={`rounded-xl flex items-center justify-center gap-2.5 py-3 outline-none text-sm ${className}`}
    >
      <SVG
        name={svg_name}
        classname={`${svgClassName} ${svgShadow ? "drop-shadow-md" : ""}`}
      />
      {textShadow && <span className="drop-shadow-md">{text}</span>}
      {!textShadow && <span>{text}</span>}
    </Link>
  );
}
